import { adminMainRoutes } from "./adminRoutes";
import { hradminMainRoutes, employeeMainRoutes } from "./hrRoutes";
import { salesadminMainRoutes, salespersonMainRoutes } from "./salesRoutes";
import { trainerMainRoutes, projectownerMainRoutes, projectassistantMainRoutes } from "./trainingRoutes";
import { clientMainRoutes } from "./clientRoutes";
import { lazyLoad } from "./helpers";

const EmployeeProfileView = lazyLoad("HRMS/Employee/EmployeeProfileView");
const selfProfileRoute = {
  path: "EmployeeProfile",
  element: <EmployeeProfileView />,
  hidden: true,
};

export { getUserRoutes, usePayrollApproverRoutes } from "./payrollApproverRoutes";

export const routesConfig = {
  trainer: [...trainerMainRoutes, ...employeeMainRoutes, selfProfileRoute],
  client: [...clientMainRoutes, selfProfileRoute],
  projectowner: [...projectownerMainRoutes, selfProfileRoute],
  projectassistant: [...projectassistantMainRoutes, ...employeeMainRoutes, selfProfileRoute],
  salesadmin: [...salesadminMainRoutes, ...employeeMainRoutes, selfProfileRoute],
  salesperson: [...salespersonMainRoutes, ...employeeMainRoutes, selfProfileRoute],
  hradmin: [...hradminMainRoutes, selfProfileRoute],
  employee: [...employeeMainRoutes, selfProfileRoute],
  admin: [
    ...adminMainRoutes,
    ...salesadminMainRoutes,
    ...hradminMainRoutes,
    ...trainerMainRoutes,
    selfProfileRoute,
  ],
};
